import React from "react";
import { Modal, InputNumber, Divider } from "antd";

interface PrintConfigModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onOk: () => void;
  printQty: number;
  setPrintQty: (val: number) => void;
  printCols: number;
  setPrintCols: (val: number) => void;
  printMarginTop: number;
  setPrintMarginTop: (val: number) => void;
  printMarginLeft: number;
  setPrintMarginLeft: (val: number) => void;
  printColGap: number;
  setPrintColGap: (val: number) => void;
  printRowGap: number;
  setPrintRowGap: (val: number) => void;
}

export const PrintConfigModal: React.FC<PrintConfigModalProps> = ({
  isOpen,
  onCancel,
  onOk,
  printQty,
  setPrintQty,
  printCols,
  setPrintCols,
  printMarginTop,
  setPrintMarginTop,
  printMarginLeft,
  setPrintMarginLeft,
  printColGap,
  setPrintColGap,
  printRowGap,
  setPrintRowGap
}) => {
  return (
    <Modal
      title="Print Label Sheet Setup"
      open={isOpen}
      onCancel={onCancel}
      okText="Generate Print Sheet"
      cancelText="Cancel"
      onOk={onOk}
    >
      <div className="space-y-4 py-4">
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="text-xs text-gray-500 block mb-1">Total Print Quantity</label>
            <InputNumber 
              min={1} 
              max={500} 
              value={printQty} 
              onChange={(val) => setPrintQty(val || 1)} 
              className="w-full"
            />
          </div>
          <div>
            <label className="text-xs text-gray-500 block mb-1">Columns (per row)</label>
            <InputNumber 
              min={1} 
              max={12} 
              value={printCols} 
              onChange={(val) => setPrintCols(val || 4)} 
              className="w-full"
            />
          </div>
        </div>

        <Divider className="my-2">Sheet Margin Setup (px)</Divider>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="text-xs text-gray-500 block mb-1">Top Margin</label>
            <InputNumber 
              min={0} 
              value={printMarginTop} 
              onChange={(val) => setPrintMarginTop(val || 0)} 
              className="w-full"
            />
          </div>
          <div>
            <label className="text-xs text-gray-500 block mb-1">Left Margin</label>
            <InputNumber 
              min={0} 
              value={printMarginLeft} 
              onChange={(val) => setPrintMarginLeft(val || 0)} 
              className="w-full"
            />
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="text-xs text-gray-500 block mb-1">Column Gap</label>
            <InputNumber 
              min={0} 
              value={printColGap} 
              onChange={(val) => setPrintColGap(val || 0)} 
              className="w-full"
            />
          </div>
          <div>
            <label className="text-xs text-gray-500 block mb-1">Row Gap</label>
            <InputNumber 
              min={0} 
              value={printRowGap} 
              onChange={(val) => setPrintRowGap(val || 0)} 
              className="w-full"
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};
